import { api } from '@/lib/api';
import { guardAvailable, guardSync } from '@/lib/guard';

const KEY = 'unmanip_prefs';

export const SHIELD_CATEGORIES = [
  { id: 'rage_bait', label: 'Rage bait', hint: 'Posts engineered to make you angry so you engage' },
  { id: 'political_manipulation', label: 'Political manipulation', hint: 'Propaganda, out-of-context quotes, fear framing' },
  { id: 'scams', label: 'Scams & phishing', hint: 'Gift cards, crypto doubling, fake giveaways, “your account is locked”' },
  { id: 'mlm', label: 'MLM / get-rich', hint: '“Be your own boss”, passive income, recruit 3 friends' },
  { id: 'engagement_bait', label: 'Engagement bait', hint: '“Share if you agree”, “type AMEN”, “99% will fail”' },
  { id: 'fake_urgency', label: 'Fake urgency', hint: 'Deadlines, “before it gets deleted”, limited spots' },
  { id: 'romance', label: 'Romance / love-bombing', hint: 'Too much too fast, moving you off-platform' },
  { id: 'health_misinfo', label: 'Health misinformation', hint: 'Miracle cures, “doctors don’t want you to know”' },
  { id: 'conspiracy', label: 'Conspiracy framing', hint: '“They” are hiding it, secret truths, do your own research' },
  { id: 'guilt_shame', label: 'Guilt & shame', hint: 'Messages that make you feel bad so you comply' },
  { id: 'clickbait', label: 'Clickbait', hint: 'Headlines that hide the point so you click' },
  { id: 'ai_fakes', label: 'AI fakes & deepfakes', hint: 'Synthetic photos, cloned voices, fake screenshots' },
];

export const ALERT_MODES = [
  { id: 'visual', label: 'Visual', hint: 'On-screen HUD and notifications' },
  { id: 'voice', label: 'Voice', hint: 'Speaks the verdict aloud — for glasses and earbuds' },
  { id: 'vibrate', label: 'Vibration', hint: '1 buzz = clear · 3 buzzes = caution · long buzz = danger' },
  { id: 'all', label: 'Everything', hint: 'Visual + voice + vibration' },
];

export const DEFAULT_PREFS = {
  blocked: ['scams', 'rage_bait', 'engagement_bait', 'fake_urgency', 'mlm'],
  allowed: [],
  alert_mode: 'visual',
  hud: true,
  hud_always: false,
  glasses: false,
  deep: false,
};

export function loadPrefs() {
  try { return { ...DEFAULT_PREFS, ...(JSON.parse(localStorage.getItem(KEY) || 'null') || {}) }; } catch { return { ...DEFAULT_PREFS }; }
}

export async function savePrefs(next) {
  const merged = { ...DEFAULT_PREFS, ...next };
  localStorage.setItem(KEY, JSON.stringify(merged));
  localStorage.setItem('unmanip_deep', merged.deep ? '1' : '0');
  window.dispatchEvent(new CustomEvent('unmanip:prefs', { detail: merged }));
  api.put('/prefs', merged).catch(() => {});
  if (guardAvailable()) {
    guardSync({ hud: merged.hud, hudAlways: merged.hud_always, alertMode: merged.alert_mode, blocked: merged.blocked.join(',') }).catch(() => {});
  }
  return merged;
}

export async function pullPrefs() {
  try {
    const remote = await api.get('/prefs').then(r => r.data);
    const merged = { ...loadPrefs(), ...remote };
    localStorage.setItem(KEY, JSON.stringify(merged));
    localStorage.setItem('unmanip_deep', merged.deep ? '1' : '0');
    return merged;
  } catch { return loadPrefs(); }
}

export const deepOn = () => localStorage.getItem('unmanip_deep') === '1';
